import React from 'react';

// Partnership Management - Payouts (User Management CSS)
const PayoutsTab = () => {
  return (
    <div className="tab-content">
      <div className="user-controls">
        <div className="search-box">
          <input type="text" placeholder="Search payouts" />
          <span className="material-icons">search</span>
        </div>
        <select className="partnership-filter-select" defaultValue="all">
          <option value="all">All Statuses</option>
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
        </select>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Partner</th>
            <th>Amount</th>
            <th>Method</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Example Teacher</td>
            <td>$50.00</td>
            <td>Bank Transfer</td>
            <td>Pending</td>
            <td>2025-01-05</td>
            <td>
              <div className="action-buttons">
                <button type="button" className="action-btn edit">View</button>
                <button type="button" className="action-btn toggle">Mark as Paid</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PayoutsTab;

